import React from 'react';
import { PropTypes } from 'prop-types';

const CallIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.266 3.46803C6.84492 -0.355162 11.6429 -1.12882 14.7084 1.70504C17.7739 4.5389 17.9367 12.3602 14.7084 15.8089C11.4801 19.2576 4.03932 18.1512 1.50563 15.8089C-1.02805 13.4667 -0.312916 7.29121 3.266 3.46803Z"
      // eslint-disable-next-line react/destructuring-assignment
      fill={props.color}
      {...props}
    />
    <path
      d="M11.7544 10.8284C11.302 10.8284 10.859 10.7578 10.4386 10.6188C10.2337 10.5482 10.0013 10.6026 9.86626 10.74L9.03373 11.3688C8.07884 10.8593 7.46748 10.2483 6.96419 9.29962L7.57594 8.48678C7.72994 8.3324 7.78514 8.10737 7.71914 7.89625C7.57979 7.474 7.50878 7.03053 7.50878 6.57895C7.50878 6.25975 7.24903 6 6.92983 6H5.57895C5.25975 6 5 6.25975 5 6.57895C5 10.3031 8.03021 13.3333 11.7544 13.3333C12.0736 13.3333 12.3333 13.0736 12.3333 12.7544V11.4074C12.3333 11.0882 12.0736 10.8284 11.7544 10.8284Z"
      fill="white"
      stroke="white"
      strokeWidth="0.3"
    />
  </svg>
);

CallIcon.propTypes = {
  color: PropTypes.string,
};

CallIcon.defaultProps = {
  color: '#FB9318',
};

export default CallIcon;
